export default {"src":"/_next/static/media/bug.ce2544ac.svg","height":786,"width":1023,"blurWidth":0,"blurHeight":0};